import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cards: [],
  selectedCard: {},
};

const cardsSlice = createSlice({
  name: 'cards',
  initialState,
  reducers: {
    setCards(state, action) {
      state.cards = action.payload;
    },
    setSelectedCard(state, action) {
      state.selectedCard = action.payload;
    },
  },
});

export const { setCards, setSelectedCard } = cardsSlice.actions;
export default cardsSlice.reducer;